export class CommonUtilsListener {
    public static bindRetryClick(retryBtn: HTMLButtonElement, onClick: (event: Event) => void): void {
        retryBtn.addEventListener("click", onClick);
    }
}
